import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const NumberBadge = styled.span({
  boxSizing: 'border-box',
  background: tokens.color.airJordan.p,
  borderRadius: '999px',
  color: tokens.color.yeezy.p,
  fontSize: tokens.fontSize[1],
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `0 ${tokens.spacing[2]}`,
  textAlign: 'center',
  height: '20px',
  minWidth: '20px',
  position: 'absolute',
  left: 'calc(100% - 13px)',
  top: '-5px',
  // 1.67px matches the svg design
  border: `1.67px solid ${tokens.color.yeezy.p}`,
  pointerEvents: 'none'
})
